import { cn, Icon } from 'corso-admin-ui';
import { DbJsonSchema } from 'corso-types';
import { useThemeSettings } from '~/hooks/useThemeSettings';

export default function StoreFaviconDisplay({
  className,
  storeName,
}: {
  className: string;
  storeName: string;
}) {
  const { data: themeSettings } = useThemeSettings();

  return (
    <div className={cn(className)}>
      {themeSettings?.merchantFaviconUrl &&
      themeSettings.merchantFaviconUrl !==
        DbJsonSchema.StoreUiConfig.defaultStoreUiTheme.merchantFaviconUrl ? (
        <img
          src={themeSettings.merchantFaviconUrl}
          alt={storeName}
          // ? maybe apply grayscale filter, but should test with transparent favicons and favicons with backgrounds
          className="size-7 rounded-lg bg-cover bg-center p-1"
        />
      ) : (
        <Icon icon="store" className="size-4" />
      )}
    </div>
  );
}
